var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common-news-item" },
    [
      _c("div", { staticClass: "news-title" }, [
        _c("div", { staticClass: "title-left" }, [
          _c(
            "a",
            {
              staticClass: "title-text link-href",
              attrs: { title: _vm.data.title },
              on: { click: _vm.clickHandle },
            },
            [_vm._v(" " + _vm._s(_vm.data.title) + " ")]
          ),
          _vm.sentiment
            ? _c(
                "span",
                {
                  staticClass: "common-positive-negative mr-8",
                  class: ["is-" + _vm.data.sensitivity],
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.sentiment) + " " + _vm._s(_vm.thePercent)
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _c("span", { staticClass: "source-text" }, [
            _vm._v("来源：" + _vm._s(_vm.data.site)),
          ]),
        ]),
        _c("span", { staticClass: "title-right source-text" }, [
          _vm._v(_vm._s(_vm.data.pubdate)),
        ]),
      ]),
      _c("div", { staticClass: "expand-text" }, [
        _c("input", { staticClass: "exp", attrs: { type: "checkbox" } }),
        _c(
          "div",
          { staticClass: "text", class: { "max-height": _vm.isOpen } },
          [
            _c(
              "div",
              {
                staticClass: "expand-btn",
                on: {
                  click: function ($event) {
                    _vm.isOpen = !_vm.isOpen
                  },
                },
              },
              [
                _vm._v(" " + _vm._s(_vm.isOpen ? "收起" : "展开") + " "),
                _c("div", { staticClass: "control fx-none fx-p-center" }, [
                  _c(
                    "div",
                    { class: ["packup", { "is-opened": _vm.isOpen }] },
                    [
                      _vm.$slots.hideBtn
                        ? _vm._t("hideBtn")
                        : _c("i", {
                            staticClass:
                              "el-select__caret el-input__icon el-icon-arrow-down",
                          }),
                    ],
                    2
                  ),
                ]),
              ]
            ),
            _c("span", [_vm._v(_vm._s(_vm.formatText(_vm.data.content)))]),
          ]
        ),
      ]),
      _c("NewsTags", { attrs: { data: _vm.data } }),
      _vm.dialogShow !== null
        ? _c("DialogNewsDetail", {
            ref: "newsDetail",
            attrs: { data: _vm.data, show: _vm.dialogShow },
            on: {
              "update:show": function ($event) {
                _vm.dialogShow = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }